import React, { useEffect, useState } from "react";

// Components

import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";
import "~/assets/sass/pages/common/settingPage/Modal/settingModal.scss";
import ProcessOne from "./contents/ProcessOne";
import ProcessTwo from "./contents/ProcessTwo";
import ProcessThree from "./contents/ProcessThree";
import ProcessFinal from "./contents/ProcessFinal";
import { Case, If } from "~/common/components/If";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";

import { useTranslation } from "react-i18next";

const Processing = ({
	settingDetail,
	setSettingDetail,
	createNew,
	roundItemModal,
	setRoundItemModal,
	setNoCategoryAlert,
	setWeightingAlert,
	setNoEvaluationAlert,
	setNoTitleAlert,
	resetItemData,
	setResetData,
	setNoCategoryName,
	setNoItemName,
	handleModify,
	handleNewCreation,
	targetIdx,
}) => {
	const { t } = useTranslation();
	const [retitle, setRetitle] = useState("");
	const [categories, setCatrgories] = useState([]);
	const [categoryName, setCatrgoryName] = useState("");
	const [categoryItems, setCategoryItems] = useState([]);
	const [selectedCategoryIdx, setSelectedCategoryIdx] = useState("");
	const [deleteIdx, setDeleteIdx] = useState("");
	const [dpDelete, setDoDelete] = useState("");
	const [itemName, setItemName] = useState("");
	const [doSetting, setDoSetting] = useState(true);
	const [weight, setWeight] = useState(0);
	//const [categoryIdxList , setCategoryIdxList] = useState([])
	const [step, setStep] = useState(1);
	const [modalClass, setModalClass] = useState("setting-summary intro");

	useEffect(() => {
		if (createNew === "create") {
			setSettingDetail({});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [createNew]);

	useEffect(() => {
		setStep(1);
		setRetitle(settingDetail.title || "");
		const categoryList = settingDetail.Category || [];
		const categoryItemList = categoryList[0];
		setDoSetting(settingDetail.weight);
		if (categoryItemList) {
			setSelectedCategoryIdx(categoryItemList.idx);
		}
		setCatrgories(categoryList);
		if (resetItemData === "reset") {
			setCategoryItems([]);
			// setResetData("")
		} else {
			categoryItemList && setCategoryItems(categoryItemList.Item);
		}
	}, [roundItemModal, settingDetail, resetItemData, setResetData]);

	useEffect(() => {
		showCategoryItems(deleteIdx);
		setDoDelete("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dpDelete]);

	useEffect(() => {
		setModalClass(
			step === 2
				? "setting-item"
				: step === 3
				? "setting-weighting"
				: step === 4
				? "setting-summary"
				: "setting-summary intro"
		);
	}, [step]);

	const handleDoSetting = (e) => {
		const change = e.target.value;
		if (change) {
			setDoSetting(!doSetting);
		}
	};

	const handleTitle = (e) => {
		setRetitle(e.target.value);
	};

	const handleWeight = (weightNum, idx) => {
		const values = [...categories];
		const weightScore = parseInt(weightNum.replace(/\D/, ""));
		if (weightScore > 100 || isNaN(weightScore)) {
			values[idx].weight = 0;
		} else {
			values[idx].weight = weightScore;
		}
		setCatrgories(values);
	};

	const addCategories = () => {
		if (categoryName.replace(/\s| /gi, "").length === 0) {
			setNoCategoryName(true);
			setCatrgoryName("");
		} else {
			const value = [...categories];
			const categoryIdx =
				categories.length !== 0 ? Math.max(...categories.map((d) => d.idx)) : 0;
			if (categoryName !== null || categoryName !== "") {
				value.push({
					idx: categoryIdx + 1,
					title: categoryName,
					weight: 0,
					Item: [],
				});
			}
			showCategoryItems(categoryIdx + 1);
			setCatrgories(value);
			setCatrgoryName("");
		}
	};

	const deleteCategory = (idx) => {
		const value = [...categories];
		value.splice(idx, 1);
		const nextShow = value[idx] === undefined ? value[value.length - 1] : value[idx];
		const nextIdx = nextShow ? nextShow.idx : "";
		setCatrgories(value);
		setDeleteIdx(nextIdx);
		setDoDelete("삭제");
	};

	const deleteItem = (idx) => {
		const selectedCate = categories.filter((d) => d.idx === selectedCategoryIdx)[0];
		const newData = categoryItems.filter((d) => d.idx !== idx);
		const newSelectedCate = { ...selectedCate, Item: newData };
		const newCategories = categories.map((d) =>
			d.idx === newSelectedCate.idx ? { ...d, ...newSelectedCate } : d
		);
		setCategoryItems(newData);
		setCatrgories(newCategories);
	};

	const addItem = () => {
		if (itemName.replace(/\s| /gi, "").length === 0) {
			setNoItemName(true);
			setItemName("");
		} else {
			const selectedCate = categories.filter((d) => d.idx === selectedCategoryIdx)[0];
			const oldItemData = selectedCate.Item;
			const categoryIdx =
				oldItemData.length !== 0 ? Math.max(...oldItemData.map((d) => d.idx)) : 0;
			const newItemData = oldItemData.concat({ idx: categoryIdx + 1, content: itemName });
			const newSelectedCate = { ...selectedCate, Item: newItemData };
			const newCategories = categories.map((d) =>
				d.idx === newSelectedCate.idx ? { ...d, ...newSelectedCate } : d
			);
			setCategoryItems(newItemData);
			setCatrgories(newCategories);
			setItemName("");
		}
	};

	const showCategoryItems = (idx) => {
		const targetCate = categories.filter((d) => d.idx === idx);
		setSelectedCategoryIdx(idx);
		if (targetCate.length === 0) {
			setCategoryItems([]);
		} else {
			setCategoryItems(targetCate[0].Item);
		}
	};

	const oneToTwo = () => {
		if (retitle.replace(/\s| /gi, "").length === 0) {
			setRetitle("");
			setNoTitleAlert(true);
		} else {
			setStep(step + 1);
		}
	};

	const twoToThree = () => {
		if (categories.length === 0) {
			setNoCategoryAlert(true);
			setStep(step);
		} else if (categories.find((d) => d.Item.length === 0)) {
			setNoEvaluationAlert(true);
			setStep(step);
		} else {
			setStep(step + 1);
		}
	};

	const threeToFinal = () => {
		const weightList = categories.map((d) => d.weight);
		let weightSum = 0;
		weightList.forEach((d) => (weightSum += d));
		if (!doSetting) {
			const newData = categories.map((d) => ({ ...d, weight: 100 / categories.length }));
			setCatrgories(newData);
			setStep(step + 1);
		} else {
			if (weightSum !== 100) {
				setWeightingAlert(true);
			} else {
				setStep(step + 1);
			}
		}
	};

	const finalConfirm = () => {
		const formData = {
			idx: targetIdx,
			title: retitle,
			weight: !!doSetting,
			Category: categories,
		};
		// createNew === "create" 일때는 신규 생성 아닐때는 수정
		if (createNew === "create") {
			handleNewCreation(formData); // 신규 생성 로직
		} else {
			handleModify(formData); // 수정 api 로직
		}
	};

	return (
		<>
			<ModalTemplate
				modalState={roundItemModal}
				setModalToggle={setRoundItemModal}
				title={t("pages.round.RoundSetting.evaluateListModal.EvalListModal.evaluationItem")}
				width={1100}
				height={680}
				className={modalClass}
			>
				<Helmet>
					<title>
						{getTitle(
							`${t("pages.round.RoundSetting.processingModal.Processing.round")}${
								createNew === "notCreate"
									? `(${retitle}) ${t(
											"pages.round.RoundSetting.processingModal.Processing.mod"
									  )}`
									: t(
											"pages.round.RoundSetting.processingModal.Processing.addEvaluate"
									  )
							}`
						)}
					</title>
				</Helmet>
				<div className="modal-content">
					<If condition={step} {...{ step, setStep, settingDetail }}>
						<Case condition={1}>
							<ProcessOne {...{ retitle, handleTitle }} />
						</Case>
						<Case condition={2}>
							<ProcessTwo
								{...{
									categories,
									categoryName,
									addCategories,
									setCatrgoryName,
									selectedCategoryIdx,
									deleteItem,
									deleteCategory,
									showCategoryItems,
									categoryItems,
									itemName,
									setItemName,
									addItem,
								}}
							/>
						</Case>
						<Case condition={3}>
							<ProcessThree
								{...{
									categories,
									handleDoSetting,
									doSetting,
									setWeight,
									handleWeight,
									weight,
								}}
							/>
						</Case>
						<Case condition={4}>
							<ProcessFinal {...{ doSetting, categories }} />
						</Case>
					</If>
				</div>
				<div className="modal-footer">
					{/* ---- 이전 vs 취소 ---- */}
					{step === 1 ? (
						<button
							type="button"
							className="btn__solid"
							color="gray"
							onClick={() => setRoundItemModal(false)}
						>
							{t("pages.round.RoundSetting.processingModal.Processing.cancel")}
						</button>
					) : (
						<button
							type="button"
							className="btn__solid"
							color="gray"
							onClick={() => setStep(step - 1)}
						>
							{t("pages.round.RoundSetting.processingModal.Processing.prev")}
						</button>
					)}

					{/* ---- 다음 vs 확인 ---- */}
					{step === 2 ? (
						<>
							<button
								type="button"
								className="btn__solid"
								color="primary"
								onClick={() => {
									setStep(twoToThree);
								}}
							>
								{t("pages.round.RoundSetting.processingModal.Processing.next")}
							</button>
						</>
					) : step === 3 ? (
						<>
							<button
								type="button"
								className="btn__solid"
								color="primary"
								onClick={threeToFinal}
							>
								{t("pages.round.RoundSetting.processingModal.Processing.next")}
							</button>
						</>
					) : step === 4 ? (
						<button
							type="button"
							className="btn__solid"
							color="primary"
							onClick={finalConfirm}
						>
							{t("pages.round.RoundSetting.processingModal.Processing.check")}
						</button>
					) : (
						<button
							type="button"
							className="btn__solid"
							color="primary"
							onClick={oneToTwo}
						>
							{t("pages.round.RoundSetting.processingModal.Processing.next")}
						</button>
					)}
				</div>
			</ModalTemplate>
		</>
	);
};

export default Processing;
